/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./infoDialog.vue?vue&type=template&id=22fa2090&scoped=true"
import script from "./infoDialog.vue?vue&type=script&lang=js"
export * from "./infoDialog.vue?vue&type=script&lang=js"
import style0 from "./infoDialog.vue?vue&type=style&index=0&id=22fa2090&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fa2090",
  null
  
)

export default component.exports